import { AppHeader } from "@relex-solutions/fragments"
import { Outlet } from "react-router"
import { AppFooter } from "../AppFooter/AppFooter"
import { CmtLogo } from "../cmtlogo/CmtLogo"
import { GlobalNavigation } from "../GlobalNavigation/GlobalNavigation"
import { LogoutButton } from "../LogoutButton/LogoutButton"
import styles from "./Layout.module.css"

interface LayoutProps {
  isUnauthorized: boolean
}

export function Layout({ isUnauthorized }: LayoutProps) {
  return (
    <div className={styles.container}>
      <AppHeader logo={<CmtLogo />} rightSlot={<LogoutButton />} />
      <div className={styles.content}>
        {!isUnauthorized && <GlobalNavigation />}
        <main className={styles.main}>
          <Outlet />
        </main>
      </div>
      <AppFooter />
    </div>
  )
}
